import { useSnapshot } from 'valtio';

import defaultSkinTone, { SkinTone } from '@cartwhl/3d/gltf/defaultSkinTone';
import Text from '@cartwhl/ui/base/Text';
import ColorPicker from '@cartwhl/ui/molecules/ColorPicker';

import { sceneSettingsStore } from 'stores';

export default function SkinTonePicker() {
  const {
    characterSettings: { skinHex, charUploadID },
  } = useSnapshot(sceneSettingsStore.state);
  return (
    <div className="border-gray-30 dark:border-gray-60 dark:bg-gray-90 rounded-2xl border bg-white p-4">
      <Text variant="studio/body/medium/sm" as="h2" className="mb-4">
        Skin color
      </Text>
      <ColorPicker
        presets={[
          SkinTone.LIGHTEST,
          SkinTone.LIGHT,
          SkinTone.MEDIUM,
          SkinTone.DARK,
          SkinTone.DARKEST,
        ]}
        onChange={(value) =>
          sceneSettingsStore.set('characterSettings', 'skinHex', value)
        }
        value={defaultSkinTone(skinHex, charUploadID)}
      />
    </div>
  );
}
